import { isFunction } from "../utils/utils"

export function observeResize(element: HTMLElement, callback: Function, defaultTimeout = 500) {

    let intervalId: number
    let observer: ResizeObserver

    if (!isFunction(window["ResizeObserver"])) {

        if (defaultTimeout > 0) {

            intervalId = window.setInterval(() => {
                callback()
            }, defaultTimeout)

        }

    }
    else {

        observer = new ResizeObserver(entries => callback())
        observer.observe(element)

    }

    return () => {

        if (observer) {
            observer.disconnect()
            observer = undefined
        }

        if (intervalId) {
            clearInterval(intervalId)
            intervalId = undefined
        }
    }

}
